<template>
  <div
    class="img-button-list"
    :class="{
      [`${size}`]: size,
      'flex-space-evenly': flexSpaceEvenly,
    }"
  >
    <div
      v-for="(btn,btnIndex) in buttonList"
      :key="btnIndex"
      class="button"
    >
      <ImgButton
        :image="btn.image"
        :text-label="btn.textLabel"
        :is-disabled="btn.disabled"
        :to="$_getRouterLink(btn.link)"
        :disabled-text="btn.disabledText"
        :disabled-icon="btn.disabledIcon"
        multiline-ellipsis
        :is-row="isRow"
        :links="btn.links"
        :isDisablePointer="btn.isDisablePointer"
        :isDisableHover="btn.isDisableHover"
        :justifyContent="btn.justifyContent"
        :bigText="btn.bigText"
        :leadingImage="btn.leadingImage"
        :description="btn.description"
        :padding="padding"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ImgButtonList",
  props: {
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
    isRow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    flexSpaceEvenly: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
    },
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentOrganizationId() {
      return this.$route.params.organizationId;
    },
  },
  methods: {
    $_getRouterLink(link) {
      if (!link) return '';
      if (this._currentFactoryId) {
        return `/factory/${this._currentFactoryId}${link}`;
      } else if (this._currentOrganizationId) {
        return `/organization/${this._currentOrganizationId}${link}`;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/img-button-list";
</style>